export function handleApiError(error) {
  let statusCode = error?.response?.status || "Unknown";
  let message =
    error?.response?.data?.error || error.message || "Something went wrong";
  const customError = new Error(message);
  customError.statusCode = statusCode;
  return customError;
}
